export default __webpack_public_path__ + "static/newspace-logo-9a1ee6bef5fa3c0abf7f875029c4c1c0.png";